import { environment } from '@env/environment';
import { Injectable } from '@angular/core';

@Injectable()

export class LoggerService {
  log(res) {
    if (!environment.production) {
      console.log('[LOGGER]', res);
    }
  }

}
